module.exports = __webpack_public_path__ + "static/media/steel-toe-capped-boots.fab113c8.jpg";